const ALLOWED_TYPES = ["buyer", "seller", "both"];
const ALLOWED_STATUSES = ["lead", "active", "inactive", "closed"];

export function parseBooleanParam(raw) {
  if (raw == null || raw === "") return false;
  const value = String(raw).toLowerCase();
  return value === "true" || value === "1";
}

export function readClientListQueryParams(search) {
  const params = new URLSearchParams(search || "");
  const rawQuery = params.get("q") || "";
  const types = params
    .getAll("type")
    .filter((v) => ALLOWED_TYPES.includes(v));
  const statuses = params
    .getAll("status")
    .filter((v) => ALLOWED_STATUSES.includes(v));
  return {
    query: rawQuery,
    types,
    statuses,
    hasNewMatches: parseBooleanParam(params.get("has_new_matches")),
    hasOverdueTasks: parseBooleanParam(params.get("has_overdue_tasks")),
  };
}

export function buildServerFetchParams({
  query = "",
  types = [],
  statuses = [],
  hasNewMatches = false,
  hasOverdueTasks = false,
} = {}) {
  const params = {};
  const trimmed = String(query || "").trim();
  if (trimmed) {
    params.search = trimmed;
  }
  if (types.length > 0) {
    params.type = types;
  }
  if (statuses.length > 0) {
    params.status = statuses;
  }
  if (hasNewMatches) {
    params.has_new_matches = true;
  }
  if (hasOverdueTasks) {
    params.has_overdue_tasks = true;
  }
  return params;
}
